import { ref } from 'vue'

export const mobileVersion = ref<string | null>(null)
